import api from "./api";

const adUnitService = {
  getAdUnits: async (params?: any) => {
    try {
      const response = await api.get("/ad-units", { params });
      return response.data;
    } catch (error) {
      console.error("Ad units API error:", error);
      throw error;
    }
  },

  getAdUnit: async (id: number) => {
    try {
      const response = await api.get(`/ad-units/${id}`);
      return response.data;
    } catch (error) {
      console.error("Ad unit API error:", error);
      throw error;
    }
  },

  createAdUnit: async (data: any) => {
    try {
      const response = await api.post("/ad-units", data);
      return response.data;
    } catch (error) {
      console.error("Create ad unit API error:", error);
      throw error;
    }
  },

  updateAdUnit: async (id: number, data: any) => {
    try {
      const response = await api.put(`/ad-units/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Update ad unit API error:", error);
      throw error;
    }
  },

  deleteAdUnit: async (id: number) => {
    try {
      const response = await api.delete(`/ad-units/${id}`);
      return response.data;
    } catch (error) {
      console.error("Delete ad unit API error:", error);
      throw error;
    }
  },

  bulkUpdateAdUnits: async (data: { ids: number[]; status: string }) => {
    try {
      const response = await api.post("/ad-units/bulk-update", data);
      return response.data;
    } catch (error) {
      console.error("Bulk update API error:", error);
      throw error;
    }
  },

  getAdUnitStatistics: async () => {
    try {
      const response = await api.get("/ad-units/statistics");
      return response.data;
    } catch (error) {
      console.error("Ad unit statistics API error:", error);
      throw error;
    }
  },
};

export default adUnitService;
